import React from 'react';

const SkeletonLoader = ({ className = '' }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      <div className="bg-gray-600 rounded"></div>
    </div>
  );
};

export const ProfileSkeleton = () => (
  <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
    <div className="mb-8">
      <SkeletonLoader className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 rounded-full border-4 border-gray-600" />
    </div>
    <div className="mb-8">
      <SkeletonLoader className="h-12 w-64 mb-4" />
      <SkeletonLoader className="h-6 w-80 mb-2" />
      <SkeletonLoader className="h-6 w-72" />
    </div>
    <div className="space-y-2">
      <SkeletonLoader className="h-4 w-96" />
      <SkeletonLoader className="h-4 w-80" />
      <SkeletonLoader className="h-4 w-88" />
    </div>
  </div>
);

export const ProjectSkeleton = () => (
  <div className="relative rounded-2xl p-6 bg-gray-800/50">
    <SkeletonLoader className="mb-6 h-[250px] rounded-lg" />
    <div className="space-y-4">
      <SkeletonLoader className="h-6 w-3/4" />
      <SkeletonLoader className="h-4 w-1/3" />
      <SkeletonLoader className="h-4 w-full" />
      <SkeletonLoader className="h-4 w-5/6" />
      <div className="flex gap-2 pt-2">
        <SkeletonLoader className="h-8 w-16" />
        <SkeletonLoader className="h-8 w-16" />
        <SkeletonLoader className="h-8 w-16" />
      </div>
    </div>
  </div>
);

export default SkeletonLoader;